// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * core-service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SortColumnV1APIModel,
    SortColumnV1APIModelFromJSON,
    SortColumnV1APIModelFromJSONTyped,
    SortColumnV1APIModelToJSON,
} from './';

/**
 * 
 * @export
 * @interface PageV1APIModel
 */
export interface PageV1APIModel {
    /**
     * 
     * @type {number}
     * @memberof PageV1APIModel
     */
    limit: number;
    /**
     * 
     * @type {number}
     * @memberof PageV1APIModel
     */
    offset: number;
    /**
     * 
     * @type {Array<SortColumnV1APIModel>}
     * @memberof PageV1APIModel
     */
    sortBy?: Array<SortColumnV1APIModel>;
}

export function PageV1APIModelFromJSON(json: any): PageV1APIModel {
    return PageV1APIModelFromJSONTyped(json, false);
}

export function PageV1APIModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageV1APIModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'limit': json['limit'],
        'offset': json['offset'],
        'sortBy': !exists(json, 'sortBy') ? undefined : ((json['sortBy'] as Array<any>).map(SortColumnV1APIModelFromJSON)),
    };
}

export function PageV1APIModelToJSON(value?: PageV1APIModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'limit': value.limit,
        'offset': value.offset,
        'sortBy': value.sortBy === undefined ? undefined : ((value.sortBy as Array<any>).map(SortColumnV1APIModelToJSON)),
    };
}


